// Salidas del wizard. El mock las pone SIEMPRE en el pie de la card, nunca en la topbar
// (`layout.css` §wizard-card-foot: izquierda «← Volver», centro la salida, derecha la acción).
//
// El contexto existe porque quien abre el modal de prospecto es el pie de cada paso, pero quien
// lo monta es el shell — y la topbar, que vive fuera del shell en la captura de teléfono, tiene
// que poder no ofrecerlo cuando todavía no hay sesión.
import { createContext, useContext } from 'react';

export interface WizardExitApi {
    /** El paso admite guardar la venta como prospecto (el silo solo acepta ciertos pasos). */
    canSaveProspect: boolean;
    /** Abre el modal que pide el motivo antes de salir. */
    openProspectDrawer: () => void;
    /** La venta sigue abierta y se puede cancelar. */
    canCancelSale?: boolean;
    /** Abre la confirmación de «Cancelar venta». */
    openCancelDialog?: () => void;
}

const WizardExitContext = createContext<WizardExitApi | null>(null);

export const WizardExitProvider = WizardExitContext.Provider;

/** `null` fuera del shell (captura de teléfono): ahí la salida es un enlace pelón al portal. */
export function useWizardExit(): WizardExitApi | null {
    return useContext(WizardExitContext);
}
